import { classes, NotImageStyle } from './style'
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported'
import Typography from '@mui/material/Typography'

const NotImage = () => {
  return (
    <NotImageStyle className={classes.root}>
      <ImageNotSupportedIcon/>
      <Typography variant="caption">
        Preview not available*
      </Typography>
    </NotImageStyle>
  )
}

export default NotImage
